let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dAEGL")).then(() => parcelRequire('a5mSh'));